// /resources/js/app/modules/v2/V2Renderer.js
import { formatPct } from '../../../utils/formatters.js';
import { v2TemplateBuilder } from './V2TemplateBuilder.js'; // <-- IMPORT THE NEW BUILDER

class V2Renderer {
    constructor() {
        this.dom = {
            navigator: document.querySelector('#stream-navigator-container nav'),
            feedContent: document.getElementById('v2-feed-content'),
            pagination: document.getElementById('v2-pagination-container'),
            viewSwitcher: document.getElementById('v2-view-switcher'),
            loadingState: document.getElementById('v2-loading-state'),
            cardViewSorter: document.getElementById('v2-card-view-sorter'),
            statusContainer: document.getElementById('v2-status-container'),
            statusText: document.getElementById('v2-status-text'),
            statusTimer: document.getElementById('v2-status-timer'),
            statusSpinner: document.getElementById('v2-status-spinner'),
            refreshBanner: document.getElementById('v2-refresh-banner'),
            refreshCount: document.getElementById('v2-refresh-count'),
            // --- START: ADD THIS NEW ELEMENT ---
            streamContextHeader: document.getElementById('v2-stream-context-header'),
            // --- END: ADD THIS NEW ELEMENT ---
        };
    }

    renderStreamNavigator(streams, user) {
        let navHtml = '';
        if (user && user.id) {
            // DELEGATE HTML GENERATION
            navHtml += v2TemplateBuilder.buildStreamTab({ slug: 'my-signals', name: '/my/signals' });
        }
        streams.forEach(stream => {
            // DELEGATE HTML GENERATION
            navHtml += v2TemplateBuilder.buildStreamTab(stream);
        });
        this.dom.navigator.innerHTML = navHtml;
    }

    renderCardView(signals, sort, isMySignalsStream = false) {
        //this.dom.cardViewSorter.classList.remove('hidden');
        this.dom.cardViewSorter.querySelectorAll('.sort-btn').forEach(btn => {
            const sortBy = btn.dataset.sortBy;
            const defaultDir = btn.dataset.defaultDir || 'desc';
            const isActive = sortBy === sort.by;
            
            btn.classList.toggle('bg-surface', isActive);
            btn.classList.toggle('text-primary', isActive);
    
            const arrowSpan = btn.querySelector('.sort-arrow') || document.createElement('span');
            arrowSpan.className = 'sort-arrow ml-1';
            if (isActive) {
                arrowSpan.innerHTML = sort.dir === 'asc' ? '▲' : '▼';
            } else {
                arrowSpan.innerHTML = '';
            }
            if (!btn.querySelector('.sort-arrow')) {
                btn.appendChild(arrowSpan);
            }
        });
    
        if (!signals || signals.length === 0) {
            this.renderEmptyState();
            return;
        }
        // DELEGATE HTML GENERATION
        const cardHtml = signals.map(s => v2TemplateBuilder.buildSignalCard(s, isMySignalsStream)).join('');
        this.dom.feedContent.innerHTML = `<div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-6">${cardHtml}</div>`;
    }
    
    renderTableView(signals, sort) {
        //this.dom.cardViewSorter.classList.add('hidden');
        if (!signals || signals.length === 0) {
            this.renderEmptyState();
            return;
        }
        // DELEGATE HTML GENERATION
        const tableHtml = `
            <div class="bg-surface border border-secondary rounded-lg overflow-hidden">
                <table class="min-w-full">
                    ${v2TemplateBuilder.buildTableHeader(sort)}
                    <tbody class="divide-y divide-secondary">
                        ${signals.map(s => v2TemplateBuilder.buildTableRow(s)).join('')}
                    </tbody>
                </table>
            </div>
        `;
        this.dom.feedContent.innerHTML = tableHtml;
    }

    renderPagination(paginationData, clickHandler) {
        if (!paginationData || !paginationData.links || paginationData.total <= paginationData.per_page) {
            this.dom.pagination.innerHTML = '';
            return;
        }
        let linksHtml = paginationData.links.map(link => {
            const label = link.label.replace('&laquo;', '«').replace('&raquo;', '»');
            if (!link.url) return `<span class="px-3 py-1 rounded-md bg-secondary opacity-50">${label}</span>`;
            const isActive = link.active ? 'bg-primary text-background' : 'bg-secondary hover:bg-primary/20';
            const page = new URL(link.url, window.location.origin).searchParams.get('page');
            return `<button data-page="${page}" class="px-3 py-1 rounded-md ${isActive}">${label}</button>`;
        }).join('');

        this.dom.pagination.innerHTML = `
            <div class="flex items-center space-x-2">${linksHtml}</div>
            <div class="text-xs text-text-dark absolute right-0">
                Showing ${paginationData.from}-${paginationData.to} of ${paginationData.total}
            </div>
        `;
        this.dom.pagination.querySelectorAll('button[data-page]').forEach(button => {
            button.addEventListener('click', () => clickHandler(button.dataset.page));
        });
    }

    updateStatusDisplay({ text, timer = '', isLoading = false }) {
        if (this.dom.statusText) this.dom.statusText.textContent = text;
        if (this.dom.statusTimer) this.dom.statusTimer.textContent = timer;
        if (this.dom.statusSpinner) this.dom.statusSpinner.classList.toggle('hidden', !isLoading);
    }
    
    showRefreshBanner(count) {
        if (this.dom.refreshBanner && count > 0) {
            this.dom.refreshCount.textContent = count;
            this.dom.refreshBanner.classList.remove('hidden');
        }
    }

    hideRefreshBanner() {
        if (this.dom.refreshBanner) {
            this.dom.refreshBanner.classList.add('hidden');
        }
    }
    
    renderLoadingState() { this.dom.feedContent.innerHTML = this.dom.loadingState.outerHTML; }
    renderEmptyState(message = 'No signals found for this stream.') { this.dom.feedContent.innerHTML = `<div class="flex items-center justify-center h-full text-center p-16 text-text-muted"><p>${message}</p></div>`; }
    renderErrorState(message) {
        this.dom.feedContent.innerHTML = `<div class="flex items-center justify-center h-full text-center p-16 text-danger"><p class="font-bold">An Error Occurred</p><p>${message}</p></div>`;
    }

    updateStreamTabBadge(slug, count) {
        const tab = this.dom.navigator.querySelector(`[data-stream-slug="${slug}"]`);
        if (!tab) return;
        
        const badge = tab.querySelector('.stream-badge');
        if (badge) {
            if (count > 0) {
                badge.textContent = `+${count}`;
                badge.classList.remove('hidden');
            } else {
                badge.classList.add('hidden');
            }
        }
    }
    
    updateMySignalsBadge(count) {
        this.updateStreamTabBadge('my-signals', count);
    }

    updateActiveStream(slug) {
        this.dom.navigator.querySelectorAll('[data-stream-slug]').forEach(tab => {
            const isActive = tab.dataset.streamSlug === slug;
            const spans = tab.querySelectorAll('span');
            const cursorSpan = tab.querySelector('.animate-cursor');

            // --- START: MODIFIED GLOW LOGIC ---
            if (isActive) {
                tab.style.filter = 'drop-shadow(0 0 5px rgba(0, 255, 127, 0.6))';
                spans.forEach(span => span.classList.add('text-primary'));
                spans.forEach(span => span.classList.remove('text-text-muted', 'text-text-dark'));
                if(cursorSpan) cursorSpan.classList.remove('opacity-0');
            } else {
                tab.style.filter = 'none';
                spans.forEach(span => span.classList.remove('text-primary'));
                spans.forEach(span => span.classList.add('text-text-muted'));
                if(cursorSpan) cursorSpan.classList.add('opacity-0');
            }
            // --- END: MODIFIED GLOW LOGIC ---
        });
    }

    // --- START: ADD THIS NEW METHOD ---
    renderStreamContext(stream) {
        if (!this.dom.streamContextHeader) return;

        if (stream && stream.name && stream.description) {
            this.dom.streamContextHeader.innerHTML = `
                <div class="font-mono text-xs text-text-muted flex items-baseline space-x-2 overflow-hidden w-full">
                    <span class="font-bold text-text-base flex-shrink-0">> ${stream.name.toUpperCase()}</span>
                    <span class="text-text-dark flex-shrink-0">-</span>
                    <span class="truncate min-w-0">${stream.description}</span>
                </div>
            `;
        } else {
            this.dom.streamContextHeader.innerHTML = '';
        }
    }
    // --- END: ADD THIS NEW METHOD ---

    /*
    updateViewSwitcher(mode) {
        this.dom.viewSwitcher.querySelectorAll('.view-mode-btn').forEach(btn => {
            const isActive = btn.dataset.viewMode === mode;
            btn.classList.toggle('bg-surface', isActive);
            btn.classList.toggle('text-text-base', isActive);
            btn.classList.toggle('text-text-muted', !isActive);
        });
    }
    */

    updateSignalDOM(consolidatedSignal, liveApiData) {
        const assetId = consolidatedSignal.asset_info.id;
        const cardElement = document.querySelector(`[data-asset-id="${assetId}"]`);
        if (!cardElement) return;

        // Loop through each variant of the consolidated signal
        consolidatedSignal.variants.forEach(variant => {
            const callId = variant.call_id;
            // Find the specific market data panel for this variant inside the card
            const panel = cardElement.querySelector(`[data-call-id="${callId}"]`);
            if (!panel) return;

            const pnlSpan = panel.querySelector('[data-live="pnl"]');
            if (!pnlSpan) return; // This variant might be locked and have no live PNL span

            const entryPrice = parseFloat(panel.dataset.entryPrice);
            const newPrice = parseFloat(liveApiData.priceUsd);

            if (!isNaN(entryPrice) && entryPrice > 0) {
                const oldPnl = parseFloat(panel.dataset.lastPnl || 0);
                const newPnl = ((newPrice - entryPrice) / entryPrice) * 100;
                
                if (oldPnl.toFixed(2) !== newPnl.toFixed(2)) {
                    // Use the renderer's own helper methods to animate the change
                    this._animateNumber(pnlSpan, oldPnl, newPnl, 500);
                    this._flashElement(pnlSpan, newPnl > oldPnl ? 'success' : 'danger');
                    panel.dataset.lastPnl = newPnl;
                }
            }
        });
    }
        
    // --- START: PASTE THIS NEW METHOD HERE ---
    /**
     * Renders a specific empty state for the "My Signals" tab based on connection status.
     * @param {boolean} isConnected - Whether the user is fully connected to Telegram.
     */
    renderMySignalsEmptyState(isConnected) {
        if (isConnected) {
            this.renderEmptyState("You haven't contributed any signals yet. They will appear here once you do.");
        } else {
            // Find the CTA template we added to the main blade file.
            const ctaTemplate = document.getElementById('v2-connect-telegram-cta');
            if (ctaTemplate) {
                this.dom.feedContent.innerHTML = ctaTemplate.outerHTML;
                // The template is hidden by default, so we must un-hide the cloned element.
                this.dom.feedContent.firstElementChild.classList.remove('hidden');
            } else {
                // Failsafe in case the template is missing.
                this.renderErrorState("Could not load the connection prompt. Please refresh the page.");
            }
        }
    }


    renderAllStreamTotalCounts(streamTotalCounts) {
        if (!this.dom.navigator) return;

        this.dom.navigator.querySelectorAll('[data-stream-slug]').forEach(tab => {
            const slug = tab.dataset.streamSlug;
            const count = streamTotalCounts[slug];
            const badge = tab.querySelector('.stream-total-badge');

            if (badge) {
                if (typeof count === 'number' && count >= 0) {
                    badge.textContent = `(${count})`;
                    badge.classList.remove('hidden');
                } else {
                    badge.classList.add('hidden');
                }
            }
        });
    }
    
    // --- END: PASTE THIS NEW METHOD HERE ---
    _animateNumber(element, startValue, endValue, duration) {
        if (element.animationFrameId) {
            cancelAnimationFrame(element.animationFrameId);
        }
        const startTime = performance.now();
        const step = (currentTime) => {
            const elapsedTime = currentTime - startTime;
            const progress = Math.min(elapsedTime / duration, 1);
            const easedProgress = 1 - Math.pow(1 - progress, 3);
            const currentValue = startValue + (endValue - startValue) * easedProgress;
            element.innerHTML = formatPct(currentValue, true);
            if (progress < 1) {
                element.animationFrameId = requestAnimationFrame(step);
            } else {
                element.innerHTML = formatPct(endValue, true);
            }
        };
        element.animationFrameId = requestAnimationFrame(step);
    }

    _addEventBadge(element, text) {
        const existingBadge = element.querySelector('.event-badge');
        if (existingBadge) return;
        const badge = document.createElement('div');
        badge.className = 'event-badge absolute -top-2 -right-2 bg-amber-500 text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full z-10';
        badge.textContent = text;
        const container = element.querySelector('.relative-container');
        if(container) container.appendChild(badge);
        setTimeout(() => badge.remove(), 5000);
    }

    _flashElement(element, type) {
        const className = type === 'success' ? 'flash-success' : 'flash-danger';
        element.classList.add(className);
        setTimeout(() => element.classList.remove(className), 600);
    }
}

export const v2Renderer = new V2Renderer();